import axios from 'axios'
import { apiURL } from '../config'

const apiClient = axios.create({
  baseURL: apiURL,
  headers: {
    'Content-Type': 'application/json',
  },
})

const apiService = (endpoint) => {
  return {
    list: async (filters = {}) => {
      try {
        const response = await apiClient.get(`${endpoint}/`, { params: filters })
        return response.data
      } catch (error) {
        console.error(`Error:`, error)
        throw error
      }
    },

    show: async (id) => {
      try {
        const response = await apiClient.get(`${endpoint}/${id}`)
        return response.data
      } catch (error) {
        console.error(`Error:`, error)
        throw error
      }
    },
  }
}

export { apiClient }
export default apiService
